import { handleActions } from 'redux-actions';
import * as actions from '../../actions/emision/catalogos.actions';

const initialState = {
  loadingMunicipios: false,
  loadingColonias: false,
  municipios: [],
  colonias: [],
};

const EmisionAseguradosReducer = handleActions(
  {
    [actions.setMunicipiosAction]: (state, { payload }) => ({
      ...state,
      municipios: [...payload],
    }),
    [actions.setColoniasAction]: (state, { payload }) => ({
      ...state,
      colonias: [...payload],
    }),
    [actions.setLoadingMunicipiosAction]: (state, { payload }) => ({
      ...state,
      loadingMunicipios: payload,
    }),
    [actions.setLoadingColoniasAction]: (state, { payload }) => ({
      ...state,
      loadingColonias: payload,
    }),
  },
  initialState,
);

export default EmisionAseguradosReducer;
